<template>
	<div :class="`mb${gap}`">
		<core-notes-card
			notesOf="case"
			:id="computedCaseId"
			:canWrite="canWrite"
			:list="notes"
			@note:created="fetchNotes"
			@note:updated="fetchNotes"
			@note:deleted="fetchNotes"
		/>
	</div>
</template>

<script>
import CoreNotesCard from "@/modules/core/components/CoreNotesCard"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"
import { can } from "@/permissions/"

export default {
	components: { CoreNotesCard },
	props: {
		caseId: {
			type: String,
			default: "",
		},

		/**
		 * Vertical gap between fields
		 * It translates into mb{gap} class
		 */
		gap: {
			type: String,
			default: "4",
		},
	},

	data() {
		return {
			notes: [],
		}
	},

	computed: {
		/**
		 * If policyId is provided via prop, use it, otherwise take it from route
		 */
		computedCaseId() {
			return this.caseId ? this.caseId : this.$route.params.id
		},

		canWrite() {
			// HACK: always return true while we do not have permissions
			return true
			return can("writeCaseNotes")
		},
	},

	methods: {
		async fetchNotes() {
			const query = gql`
				query caseNotes($where: caseWhere) {
					cases(where: $where) {
						list {
							notes {
								id
								title
								content
								createdAt
								createdBy {
									username
									associatedUser {
										name
									}
								}
							}
						}
					}
				}
			`

			const res = await api({
				query,
				variables: { where: { id: this.computedCaseId } },
			})

			this.notes = res?.data?.cases?.list?.[0]?.notes
		},
	},

	mounted() {
		this.fetchNotes()
	},
}
</script>
